<h1 mat-dialog-title>
  <app-titulo-paginas titulo="{{kit.name | titlecase}}"></app-titulo-paginas>
</h1>
<mat-dialog-content>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-3">
          <label>Nome:</label>
          <p>{{kit.name}}</p>
        </div>
        <div class="col-lg-3">
          <label>Preço:</label>
          <p>{{ kit.price | currency: 'BRL'}}</p>
        </div>
        <div class="col-lg-3">
          <label for="codigoBarra">Quantidade de Produtos:</label>
          <p>{{ kit.kit_products.length }} Produto(s)
          </p>
        </div>
      </div>
      <hr>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">Produto</th>
          <th scope="col">Quantidade</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of kit.kit_products">
          <td>
            {{product.ml_products_company.ml_products_table_versions_prices?.product?.description}}
            {{product.ml_products_company.ml_products_table_versions_prices?.product?.content}}
          </td>
          <td>
            {{product.quantity}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button type="button" class="btn btn-secondary" (click)="dialogRef.close()" style="border-radius: 19px">
    Fechar
  </button>
</mat-dialog-actions>
